import React from 'react';
import { useFeatureFlagsData } from 'hooks';

export default Component => props => (
    <Component {...props} flags={useFeatureFlagsData()} />
);
